export const UPDATE_APPLICATION_EMAIL = 'UPDATE_APPLICATION_EMAIL';
export type UPDATE_APPLICATION_EMAIL = typeof UPDATE_APPLICATION_EMAIL;

export const UPDATE_APPLICATION_FIRST_NAME = 'UPDATE_APPLICATION_FIRST_NAME';
export type UPDATE_APPLICATION_FIRST_NAME = typeof UPDATE_APPLICATION_FIRST_NAME;

export const UPDATE_APPLICATION_LAST_NAME = 'UPDATE_APPLICATION_LAST_NAME';
export type UPDATE_APPLICATION_LAST_NAME = typeof UPDATE_APPLICATION_LAST_NAME;

export const UPDATE_APPLICATION_ORGANIZATION = 'UPDATE_APPLICATION_ORGANIZATION';
export type UPDATE_APPLICATION_ORGANIZATION = typeof UPDATE_APPLICATION_ORGANIZATION;

export const UPDATE_APPLICATION_DESCRIPTION = 'UPDATE_APPLICATION_DESCRIPTION';
export type UPDATE_APPLICATION_DESCRIPTION = typeof UPDATE_APPLICATION_DESCRIPTION;

export const UPDATE_APPLICATION_OAUTH_REDIRECT_URL = 'UPDATE_APPLICATION_OAUTH_REDIRECT_URL';
export type UPDATE_APPLICATION_OAUTH_REDIRECT_URL = typeof UPDATE_APPLICATION_OAUTH_REDIRECT_URL;

export const TOGGLE_BENEFITS_CHECKED = 'TOGGLE_BENEFITS_CHECKED';
export type TOGGLE_BENEFITS_CHECKED = typeof TOGGLE_BENEFITS_CHECKED;

export const TOGGLE_CLAIMS_CHECKED = 'TOGGLE_CLAIMS_CHECKED';
export type TOGGLE_CLAIMS_CHECKED = typeof TOGGLE_CLAIMS_CHECKED;

export const TOGGLE_APPEALS_CHECKED = 'TOGGLE_APPEALS_CHECKED';
export type TOGGLE_APPEALS_CHECKED = typeof TOGGLE_APPEALS_CHECKED;

export const TOGGLE_HEALTH_CHECKED = 'TOGGLE_HEALTH_CHECKED';
export type TOGGLE_HEALTH_CHECKED = typeof TOGGLE_HEALTH_CHECKED;

export const TOGGLE_COMMUNITY_CARE_CHECKED = 'TOGGLE_COMMUNITY_CARE_CHECKED';
export type TOGGLE_COMMUNITY_CARE_CHECKED = typeof TOGGLE_COMMUNITY_CARE_CHECKED;

export const TOGGLE_CONFIRMATION_CHECKED = 'TOGGLE_CONFIRMATION_CHECKED';
export type TOGGLE_CONFIRMATION_CHECKED = typeof TOGGLE_CONFIRMATION_CHECKED;

export const TOGGLE_VA_FORMS_CHECKED = 'TOGGLE_VA_FORMS_CHECKED';
export type TOGGLE_VA_FORMS_CHECKED = typeof TOGGLE_VA_FORMS_CHECKED;

export const TOGGLE_VERIFICATION_CHECKED = 'TOGGLE_VERIFICATION_CHECKED';
export type TOGGLE_VERIFICATION_CHECKED = typeof TOGGLE_VERIFICATION_CHECKED;

export const TOGGLE_FACILITIES_CHECKED = 'TOGGLE_FACILITIES_CHECKED';
export type TOGGLE_FACILITIES_CHECKED = typeof TOGGLE_FACILITIES_CHECKED;

export const SUBMIT_APPLICATION_BEGIN = 'SUBMIT_APPLICATION_BEGIN';
export type SUBMIT_APPLICATION_BEGIN = typeof SUBMIT_APPLICATION_BEGIN;

export const SUBMIT_APPLICATION_SUCCESS = 'SUBMIT_APPLICATION_SUCCESS';
export type SUBMIT_APPLICATION_SUCCESS = typeof SUBMIT_APPLICATION_SUCCESS;

export const SUBMIT_APPLICATION_ERROR = 'SUBMIT_APPLICATION_ERROR';
export type SUBMIT_APPLICATION_ERROR = typeof SUBMIT_APPLICATION_ERROR;

export const TOGGLE_ACCEPT_TOS = 'TOGGLE_ACCEPT_TOS';
export type TOGGLE_ACCEPT_TOS = typeof TOGGLE_ACCEPT_TOS;

export const SET_REQUESTED_API_VERSION = 'SET_REQUESTED_APIVERSION';
export type SET_REQUESTED_API_VERSION = typeof SET_REQUESTED_API_VERSION;

export const SET_INITIAL_VERSIONING = 'SET_INITIAL_VERSIONING';
export type SET_INITIAL_VERSIONING = typeof SET_INITIAL_VERSIONING;

export const CURRENT_VERSION_IDENTIFIER = 'current';

export const FORM_FIELDS_TO_URL_FRAGMENTS = {
  benefits: 'benefits',
  claims: 'claims',
  communityCare: 'community_care',
  confirmation: 'veteran_confirmation',
  facilities: 'facilities',
  health: 'fhir',
  vaForms: 'vaForms',
  verification: 'veteran_verification',
};